module.exports = __webpack_public_path__ + "media/images/proof_links/colored/linkedin-80819046a463448a7d16a06f7cd5b39b.svg";